import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ArrowsCollapseVertical, BarChartSteps, FileEarmark } from "react-bootstrap-icons";

import {
  removePage,
  requestClonePage,
  // requestCreatePage,
  requestRemovePage,
  resetCurrentPageData,
} from "../../store/slices/projectPages";
import { Dot, OptionsIcon, PageItem, PageName, PageOptions } from "./styles";
import {
  setComparisonActionType,
  setPageIdSelected,
  setReportActionType,
} from "../../store/slices/appConfig";
import { setActiveModal } from "../../store/slices/modals";
// import { getPageSettings } from "../../store/selectors/projects";
import { getIsEditMode, getIsPageTypeSelect, getIsPublicMode } from "../../store/selectors/main";
import { PageSubmenu } from "../PageSubmenu";

interface PageTabInterface {
  name: string;
  tabId: string;
  dashType: string;
  isPublic?: boolean
}

const DASHBOARD_ICONS = {
  report: FileEarmark,
  dashboard: BarChartSteps,
  storyTelling: BarChartSteps,
  comparison: ArrowsCollapseVertical,
};

type DashboardType = "report" | "dashboard" | "storyTelling" | "comparison";

export const PageTab = ({ name, tabId, dashType, isPublic }: PageTabInterface) => {
  const isPageTypeSelect = useSelector(getIsPageTypeSelect);
  const isEditMode = useSelector(getIsEditMode);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id, pageId } = useParams();
  const isPublicRoute = useSelector(getIsPublicMode);
  const [menuOpen, setMenuOpen] = useState(false);
  // const pageSettings = useSelector(getPageSettings);
  // const {
    // id: omitId,
    // createdAt,
    // updatedAt,
    // ...duplicateSettings
  // } = pageSettings;

  const onEdit = () => {
    navigate(`/projects/${id}/${tabId}`);
    dispatch(setActiveModal({ id: "projectSettingsModal" }));
  };

  const onRemove = () => {
    dispatch(removePage(tabId));
    dispatch(requestRemovePage({ id: tabId, navigate }));
  };

  const onDuplicate = () => {
    dispatch(requestClonePage({ id: tabId, projectId: id!, navigate }));
  };

  const onCreateComparison = () => {
    dispatch(setPageIdSelected(tabId));
    dispatch(setActiveModal({ id: "createComparisonModal" }))
  };
  const onCreateReport = () => {
    dispatch(setPageIdSelected(tabId));
    // dispatch(setActiveModal({ id: "createReportModal" }))
    dispatch(setReportActionType("create"));
  };

  const IconComponent = DASHBOARD_ICONS[dashType as DashboardType] || BarChartSteps;

  return (
    <>
      <PageItem $active={!isPageTypeSelect && tabId === pageId} $menuOpen={menuOpen}>
        {/* {isPublic && <GlobeIcon />} */}
        <PageName
          onClick={() => {
            dispatch(setPageIdSelected(null));
            dispatch(setReportActionType("unset"));
            dispatch(setComparisonActionType("unset"));
            if (tabId === pageId) return;
            dispatch(resetCurrentPageData());
            const path = isPublicRoute
              ? `/projects/public/${id}/${tabId}`
              : `/projects/${id}/${tabId}`;
            navigate(path);
          }}
        >
          <IconComponent />
          {name}
        </PageName>
        {isPublic && <Dot />}
        {!isPublicRoute && isEditMode ? (
          <PageOptions
            onClick={() => {
              setMenuOpen((prevMenuOpen) => !prevMenuOpen);
            }}
          >
            <OptionsIcon />
          </PageOptions>
        ) : null}
        {menuOpen && (
          <PageSubmenu
            menuOpen={menuOpen}
            setMenuOpen={setMenuOpen}
            onEdit={onEdit}
            onRemove={onRemove}
            onDuplicate={onDuplicate}
            onCreateComparison={onCreateComparison}
            onCreateReport={onCreateReport}
            pageTabMenu
            isReportTab={dashType === "report"}
            isComparisonTab={dashType === "comparison"}
          />
        )}
      </PageItem>
    </>
  );
};
